var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.44936 9.1724C4.92097 9.1724 2.86316 7.11459 2.86316 4.5862C2.86316 2.05781 4.92097 0 7.44936 0C9.97775 0 12.0356 2.05781 12.0356 4.5862C12.0356 7.11459 9.97775 9.1724 7.44936 9.1724ZM7.44936 1.1964C5.58297 1.1964 4.05956 2.71982 4.05956 4.5862C4.05956 6.45258 5.58297 7.976 7.44936 7.976C9.31574 7.976 10.8392 6.45258 10.8392 4.5862C10.8392 2.71982 9.31574 1.1964 7.44936 1.1964Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.301 17.1484C13.9739 17.1484 13.7028 16.8773 13.7028 16.5502C13.7028 13.7985 10.8952 11.5652 7.44958 11.5652C4.00395 11.5652 1.1964 13.7985 1.1964 16.5502C1.1964 16.8773 0.925216 17.1484 0.5982 17.1484C0.271184 17.1484 0 16.8773 0 16.5502C0 13.1445 3.34194 10.3688 7.44958 10.3688C11.5572 10.3688 14.8992 13.1445 14.8992 16.5502C14.8992 16.8773 14.628 17.1484 14.301 17.1484Z",
    fill: "#292D32"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.66b96a51dc09fbde93089a6b099f5b9c.svg";
export { ForwardRef as ReactComponent };